import { ReactComponent as ModelSvg } from "./model.svg";

const ModelIcon = (props) => {
  return <ModelSvg {...props} />;
};

export default ModelIcon;
